// React
import { useMemo } from "react";

// Third party imports
import { useSelector } from "react-redux";
import { matchPath, useLocation } from "react-router-dom";

// Client pages are "/:company_id/<tab>" (routes.jsx PROTECTED_ROUTES.CLIENT_*), with a UUID id
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const selectLiteCompany = (state) => state.companies?.liteSelectedCompany;
const selectSelectedCompany = (state) => state.companies?.selectedCompany;

/**
 * Page the user is on, sent with every question: { path, company_id?, company_name? }.
 * The client name comes from Redux when the loaded client is the one in the URL.
 */
export default function usePageContext() {
  const { pathname } = useLocation();
  const liteCompany = useSelector(selectLiteCompany);
  const selectedCompany = useSelector(selectSelectedCompany);

  return useMemo(() => {
    const match = matchPath("/:companyId/*", pathname);
    const companyId = match && UUID_RE.test(match.params.companyId) ? match.params.companyId : null;
    if (!companyId) return { path: pathname };

    const sameId = (company) => company?.id && String(company.id) === companyId;
    const companyName =
      (sameId(liteCompany) && liteCompany.name) ||
      (sameId(selectedCompany) && selectedCompany.name) ||
      undefined;
    return {
      path: pathname,
      company_id: companyId,
      ...(companyName ? { company_name: companyName } : {}),
    };
  }, [pathname, liteCompany, selectedCompany]);
}
